import { render, staticRenderFns } from "./ChangeRewardSlotStatus.vue?vue&type=template&id=422b4fc4&"
import script from "./ChangeRewardSlotStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeRewardSlotStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports